module.exports = __webpack_public_path__ + "static/media/8234192981537184103.63969ccd.svg";